<template>
  <div class="h-full p-template-status__loader" v-if="loading">
    <VLoadingSpinner size="large" />
  </div>
  <div class="p-template-update g-page h-full" v-else>
    <VDocumentSetup
      :saving="saving"
      :doc="template"
      :fields="fields"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';
import VDocumentSetup from '@/views/components/DocumentSetup.vue';

export default {
  name: 'TemplateUpdate',
  components: {
    VLoadingSpinner,
    VDocumentSetup,
  },
  data() {
    return {
      loading: true,
    };
  },
  mounted() {
    const fingerprint = this.$route.params.templateId;
    this.$store.dispatch('template/GET', { id: fingerprint }).finally(() => {
      this.loading = false;
    });
  },
  computed: {
    ...mapGetters({
      template: 'template/selected',
      fields: 'template/fields',
      saving: 'template/saving',
    }),
  },
};
</script>

<style scoped>
.p-template-update {
  padding: 0 !important;
  border: 1px solid #dde2e5;
  border-radius:3px;
}
</style>
